import compose from 'lodash/fp/compose';
import { arrayOf, bool, func } from 'prop-types';
import React from 'react';
import { Alert, Col } from 'reactstrap';

import { campaignLineStatuses } from '../../campaign-editor/constants';
import { brandShape, campaignShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import { COLORS } from '../../utils/constants';

function DefaultCopyAssetsWarning({
  onSubmit,
  brands,
  campaign,
  brandsHaveChanged,
  isEditing,
}) {
  const campaignIsPushed = campaign.campaignLines.some(({ status }) =>
    [campaignLineStatuses.PUSHED, campaignLineStatuses.LOCKED].includes(status),
  );

  if (
    campaign.campaignLines.length > 0 &&
    !campaignIsPushed &&
    (onSubmit || isEditing) &&
    brands &&
    brandsHaveChanged
  ) {
    return (
      <Col>
        <Alert
          className="px-2 py-1 mt-2 font-size-small"
          color={COLORS.WARNING}
        >
          Campaign default copy assets are created for the brand &quot;
          {brands[0].name}&quot; by default. Make sure to recreate the campaign
          before it is pushed to capture the correct default copy assets.
        </Alert>
      </Col>
    );
  }
  return null;
}

DefaultCopyAssetsWarning.propTypes = {
  campaign: campaignShape.isRequired,
  onSubmit: func,
  brands: arrayOf(brandShape.isRequired).isRequired,
  brandsHaveChanged: bool.isRequired,
  isEditing: bool,
};

DefaultCopyAssetsWarning.defaultProps = {
  onSubmit: undefined,
  isEditing: false,
};

export default compose(
  withResolved({
    query: api.getBrands,
    deriveQueryArgs: ({ brandIds }) => ({
      search: { id: brandIds },
    }),
    as: 'brands',
  }),
  withResolved({
    query: api.getCampaign,
    deriveQueryArgs: ({ campaignId }) => ({ id: campaignId }),
    as: 'campaign',
  }),
)(DefaultCopyAssetsWarning);
